import { customDateParserForGuard } from './customDateParserForGuard';
import { getTimeAtWhichGuardCanBeginPatrol } from './getPatrolConstraints';

// customerAddressCount is used to determine the number of patrols for a customer at a specific address
// this will
export function convertToScheduleAssignment(item: any) {
	const scheduleAssignment: ScheduleAssignment = {
		schedule_assignment_id: parseInt(item.schedule_assignment_id),
		StartTime: item.StartTime
			? customDateParserForGuard(item.StartTime)
			: null,
		EndTime: item.EndTime ? customDateParserForGuard(item.EndTime) : null,
		cust_id: parseInt(item.cust_id),
		type: item.type,
		WorkDate: item.WorkDate
			? customDateParserForGuard(item.WorkDate)
			: null,
		cust_name: item.cust_name,
		address_id: parseInt(item.address_id),
		address: item.address,
		contact_id: parseInt(item.contact_id),
		full_name: item.full_name,
		work_date: customDateParserForGuard(item.work_date),
		start_time: customDateParserForGuard(item.start_time),
		end_time: customDateParserForGuard(item.end_time),
		assignment_start_time: new Date(item.assignment_start_time),
		case_id: parseInt(item.case_id),
		title: item.title,
		description: item.description,
		started: item.started === 'true',
		complete: item.complete === 'true',
		patrol_begin_time: item.patrol_begin_time
			? customDateParserForGuard(item.patrol_begin_time)
			: null,
		patrol_end_time: item.patrol_begin_time
			? customDateParserForGuard(item.patrol_end_time)
			: null,
		assignment_sort: parseInt(item.assignment_sort),
		vv_file_id:
			item.vv_file_id === ''
				? []
				: item.vv_file_id.split(',').map(Number),
		dds_file_id:
			item.dds_file_id === '' || item.dds_file_id === undefined
				? []
				: item.dds_file_id.split(',').map(Number), // checking for undefined because this field is set up only through the admin panel
		deliverable_id: parseInt(item.deliverable_id),
		comment_list_group_id: parseInt(item.comment_list_group_id),
		activity_id: parseInt(item.activity_id),
		comment_list_id: parseInt(item.comment_list_id) || null,
		activity_status: item.activity_status,
		online_map_url: item.online_map_url,
		WorkEnd: item.WorkEnd ? customDateParserForGuard(item.WorkEnd) : null,
		timeAtWhichGuardCanBeginPatrol: getTimeAtWhichGuardCanBeginPatrol(
			customDateParserForGuard(item.assignment_start_time),
		),
		patrolCountAtLocationString: '1 of ?', // Default to 1 of ?, its updated using addPatrolCountAtLocation function
	};
	return scheduleAssignment;
}
